import { SitesModel } from "@/Common/Models/Sites/SitesModel";

interface ITaxesSectionProps {
    gst: number;
    qst: number;
    hst: number;
    genericTaxValue: number;
    site: SitesModel;
}

function TaxesSection(props: ITaxesSectionProps): JSX.Element {
    const { qst, gst, hst, genericTaxValue, site } = props;

    return (
        <div>
            <div className="view-section-header">
                <h3 className="view-section-title">{cacheStore.GetString("TaxesLabel")}</h3>
            </div>
            <div className="view-section-body">
                {site.isGst() && (
                    <div className="row">
                        <div className="col-lg-4 col-md-2 col-sm-2 text-right">
                            <label className="form-label">{cacheStore.GetString("GstMLabel")}%</label>
                        </div>
                        <div className="col-lg-5 col-md-6 col-sm-6 form-field-answer">
                            <strong>{gst}</strong>
                        </div>
                    </div>
                )}
                {site.isPstOrQst() && (
                    <div className="row">
                        <div className="col-lg-4 col-md-2 col-sm-2 text-right">
                            <label className="form-label">{site.getPstOrQstLabel()}%</label>
                        </div>
                        <div className="col-lg-5 col-md-6 col-sm-6 form-field-answer">
                            <strong>{qst}</strong>
                        </div>
                    </div>
                )}
                {site.isHst() && (
                    <div className="row">
                        <div className="col-lg-4 col-md-2 col-sm-2 text-right">
                            <label className="form-label">{cacheStore.GetString("HstMLabel")}%</label>
                        </div>
                        <div className="col-lg-5 col-md-6 col-sm-6 form-field-answer">
                            <strong>{hst}</strong>
                        </div>
                    </div>
                )}
                {!site.isCanadaSite() && (
                    <div className="row">
                        <div className="col-lg-4 col-md-2 col-sm-2 text-right">
                            <label className="form-label">{cacheStore.GetString("TaxLabel")}%</label>
                        </div>
                        <div className="col-lg-5 col-md-6 col-sm-6 form-field-answer">
                            <strong>{genericTaxValue ?? 0}</strong>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}

export default TaxesSection;
